import React from 'react';
import { Button, ButtonProps } from '@ais-ui/ui-core';
import { PiNotebook } from 'react-icons/pi';
import { useCreateShipReport } from './useCreateShipReport';
import { useCreateReportContext } from '../../Reports/Mutations/CreateReportTemplate/CreateReportContext';

/**
 * Button component for creating ship reports
 * Pre-configures the report wizard with selected ships
 */
export const ShipReportButton = React.forwardRef<
  HTMLButtonElement,
  ButtonProps
>(({ onClick, ...props }, ref) => {
  const { createShipReport } = useCreateShipReport();
  const { setShowDialog } = useCreateReportContext();

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    // First configure the ship report settings
    createShipReport();

    // Open the dialog via context state (not via DialogTrigger)
    // This ensures the state is set before the dialog content renders
    setShowDialog(true);

    // Call the original onClick if provided (for compatibility)
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <Button
      ref={ref}
      variant="ghost"
      onClick={handleClick}
      className="flex gap-x-2 col-span-2 justify-start"
      {...props}
    >
      <PiNotebook />
      Ships Report
    </Button>
  );
});

ShipReportButton.displayName = 'ShipReportButton';
